import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../common/actions';
import {colors} from '../../common/constants/colors';
import {reverseShortDate} from '../../common/constants/datesFormat';
import {availableOptions} from '../../common/util/menuBuilder';
import HomeIcon from './homeIcon';
import './dashboard.scss';

class Dashboard extends Component {
  componentDidMount() {
    this.props.getUserOptions();
  }

  onCardClick(path) {
    this.props.navigateTo(path);
  }

  renderOptions(options, colorIndex = 0) {
    const filteredOptions = this.filterOptions(options);

    return filteredOptions.map((option, index) =>
      this.renderOption(option, index, colorIndex)
    );
  }

  filterOptions(userOptions = []) {
    return userOptions.reduce((accumulator, currentValue) => {
      const option = availableOptions.find(
        (item) => item.resource === currentValue.option
      );

      if (option) {
        accumulator.push({...option, ...currentValue});
      }

      return accumulator;
    }, []);
  }

  renderOption(option, index, colorIndex = 0) {
    const style = {
      'backgroundColor': colors[(index + colorIndex) % colors.length],
    };

    return (
      <Card
        className='option'
        key={index}
        onClick={this.onCardClick.bind(this, option.path)}
      >
        <div className='user-option'>
          <div className='icon-box' style={style}>
            <HomeIcon name={option.icon} />
          </div>
          <div className='info-box'>
            <div className='option-title'>{option.name}</div>
            <div className='option-date'>
              Acualizado el {this.getDate(option.date)}
            </div>
          </div>
        </div>
      </Card>
    );
  }

  getDate(date) {
    return moment(date).format(reverseShortDate);
  }

  render() {
    const {loadingOptions, favoriteOptions, popularOptions} = this.props;

    if (loadingOptions) {
      return (
        <div>
          <Loader active>Obteniendo información</Loader>
        </div>
      );
    }

    return (
      <div className='home-dashboard'>
        <Card raised fluid className='section'>
          <h3>
            <i className='material-icons'>stars</i>
            Favoritos
          </h3>
          <Card.Group itemsPerRow={4}>
            {this.renderOptions(favoriteOptions)}
          </Card.Group>
        </Card>

        <Card raised fluid className='section'>
          <h3>
            <i className='material-icons'>cached</i>
            Más Usados
          </h3>
          <Card.Group itemsPerRow={4}>
            {this.renderOptions(popularOptions, 9)}
          </Card.Group>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingOptions': state.menu.loadingOptions,
    'favoriteOptions': state.menu.favoriteOptions,
    'popularOptions': state.menu.popularOptions,
  };
};

const {updateMenuNavigation, getUserOptions, navigateTo, withRouter} =
  Actions;

export default withRouter(
  connect(mapStateToProps, {
    updateMenuNavigation,
    getUserOptions,
    navigateTo,
    withRouter,
  })(Dashboard)
);
